import { IconInbox, IconSend2 } from '@tabler/icons-react'
import { NavLink as Link, Outlet } from 'react-router-dom'
import { Badge, NavLink } from '@mantine/core'

export function FaxNotSelectedPage() {
  return (
    <div className="flex size-full flex-col items-center justify-center gap-4 bg-gray-50 text-center">
      <Badge variant="light" color="gray">
        No fax selected
      </Badge>
    </div>
  )
}

export function FaxPage() {
  return (
    <div className="flex size-full flex-auto">
      <div className="flex w-3xs flex-none flex-col border-r border-gray-200">
        <NavLink
          component={Link}
          leftSection={<IconInbox size={15} />}
          to="/fax/inbox"
          label="Inbox"
        />

        <NavLink
          component={Link}
          leftSection={<IconSend2 size={15} />}
          to="/fax/sent"
          label="Sent"
        />
      </div>
      <div className="flex flex-auto flex-col">
        <Outlet />
      </div>
    </div>
  )
}
